import HttpClient from './http-client';
import URL from './url';

export default class CouponPI {

    static getRewardPoints(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.REWARD + "?" + params.join('&') : URL.REWARD;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }

    static getRewardPointsActivity(payload = {}) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.REWARD_ACTIVITY + "?" + params.join('&') : URL.REWARD_ACTIVITY;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }

    static getVouchers(payload = {}) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.VOUCHERS + "?" + params.join('&') : URL.VOUCHERS;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }

    static getVoucherHistory(payload = {}) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.VOUCHER_PURCHASE_HISROTY + "?" + params.join('&') : URL.VOUCHER_PURCHASE_HISROTY;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }


    static purchaseVoucher(payload) {
        return HttpClient.post(URL.BASE_URL + URL.VOUCHERS, null, payload);
    }

    static addVideoWatchedRewardPoint (payload) {
        return HttpClient.post(URL.BASE_URL + URL.ADD_VIDEO_WATCHED_REWARD_POINT, null, payload);
    }



}
